import React from 'react';

interface CardSkeletonProps {
  /** Number of cards to show */
  count?: number;
  /** Custom className */
  className?: string;
}

/**
 * Skeleton component for card grids
 * Used in dashboard cards, product cards, etc.
 */
export const CardSkeleton: React.FC<CardSkeletonProps> = ({
  count = 3,
  className = '',
}) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ${className}`}>
      {[...Array(count)].map((_, i) => (
        <div
          key={i}
          className="animate-pulse rounded-xl bg-white border border-gray-200 p-6 shadow-sm"
        >
          <div className="h-4 w-1/3 rounded-lg bg-gray-100 mb-4" />
          <div className="h-8 w-2/3 rounded-lg bg-gray-100 mb-2" />
          <div className="h-4 w-full rounded-lg bg-gray-100" />
        </div>
      ))}
    </div>
  );
};

